module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _h('div', {
    staticClass: "star"
  }, [_h('div', {
    staticClass: "star-item",
    class: _vm.starType
  }, [_vm._l((_vm.itemClasses), function(itemClass) {
    return _h('span', {
      staticClass: "star-item",
      class: itemClass
    })
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.vue-loader@10.0.2/lib/template-compiler.js?id=data-v-64db44c0!./~/.vue-loader@10.0.2/lib/selector.js?type=template&index=0!./src/components/star/star.vue
// module id = 48
// module chunks = 1